module.exports = __webpack_public_path__ + "img/project10_6.jpg.144c7327.webp";